import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Checkbox,
  FormControlLabel,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Backdrop } from "@mui/material";
import { toast } from "react-toastify";

const UploadApp = ({ open, onClose, onSuccess }) => {
  const emailID = localStorage.getItem("user");
  const [uploadFormData, setUploadFormData] = useState({
    appName: "",
    versionCode: "",
    versionName: "",
    buildType: "",
    releaseNote: "",
    forceUpdate: false,
    emailID: emailID,
    file: null,
  });

  const [uploadLoading, setUploadLoading] = useState(false);

  const handleUploadFormChange = (e) => {
    const { name, value, files, type, checked } = e.target;
    setUploadFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : files ? files[0] : value,
    }));
  };

  const handleAppUpload = async (e) => {
    e.preventDefault();
    setUploadLoading(true);

    try {
      const formData = new FormData();
      formData.append("appName", uploadFormData.appName);
      formData.append("versionCode", uploadFormData.versionCode);
      formData.append("versionName", uploadFormData.versionName);
      formData.append("buildType", uploadFormData.buildType);
      formData.append("releaseNote", uploadFormData.releaseNote);
      formData.append("forceUpdate", uploadFormData.forceUpdate);
      formData.append("emailID", uploadFormData.emailID);
      formData.append("file", uploadFormData.file);

      const response = await fetch("https://littleinfinity.in:4001/upload-app", {
        method: "POST",
        body: formData,
      });

      if (response.status === 200 || response.status === 201) {
        setUploadFormData({
          appName: "",
          versionCode: "",
          versionName: "",
          buildType: "",
          releaseNote: "",
          forceUpdate: false,
          file: null,
        });
        onSuccess();
        toast.success("Successfully App Uploaded!");
        onClose();
      }
    } catch (error) {
      toast.error("Error:", error);
      console.error("Upload failed:", error);
    } finally {
      setUploadLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Upload New App Version</Typography>
          <IconButton
            onClick={onClose}
            sx={{
              color: "#d52029",
              "&:hover": {
                backgroundColor: "rgba(213, 32, 41, 0.1)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box component="form" onSubmit={handleAppUpload} sx={{ mt: 2 }}>
          {/* First Row - App Name and Build Type */}
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormControl fullWidth margin="normal">
                <InputLabel id="app-name-label">App Name</InputLabel>
                <Select
                  labelId="app-name-label"
                  variant="standard"
                  id="appName"
                  name="appName"
                  value={uploadFormData.appName}
                  onChange={handleUploadFormChange}
                  label="App Name"
                  required
                >
                  <MenuItem value="driver">Little Driver App</MenuItem>
                  <MenuItem value="rider">Little Rider App</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth margin="normal">
                <InputLabel id="build-type-label">Build Type</InputLabel>
                <Select
                  labelId="build-type-label"
                  variant="standard"
                  id="buildType"
                  name="buildType"
                  value={uploadFormData.buildType}
                  onChange={handleUploadFormChange}
                  label="Build Type"
                  required
                >
                  <MenuItem value="debug">Debug</MenuItem>
                  <MenuItem value="beta">Beta</MenuItem>
                  <MenuItem value="release">Release</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {/* Second Row - Version Code and Version Name */}
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                margin="normal"
                label="Version Name"
                variant="standard"
                name="versionName"
                value={uploadFormData.versionName}
                onChange={handleUploadFormChange}
                required
                placeholder="e.g. 1.0.0"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                margin="normal"
                label="Version Code"
                variant="standard"
                name="versionCode"
                value={uploadFormData.versionCode}
                onChange={handleUploadFormChange}
                required
                placeholder="e.g. 123"
              />
            </Grid>
          </Grid>

          {/* Release Notes */}
          <TextField
            fullWidth
            margin="normal"
            label="Release Note"
            name="releaseNote"
            value={uploadFormData.releaseNote}
            onChange={handleUploadFormChange}
            multiline
            rows={4}
            placeholder="Enter release notes..."
          />

          {/* Force Update Checkbox */}
          <FormControlLabel
            control={
              <Checkbox
                name="forceUpdate"
                checked={uploadFormData.forceUpdate}
                onChange={handleUploadFormChange}
                color="primary"
              />
            }
            label="Force Update"
            sx={{ mt: 1 }}
          />

          {/* File Upload */}
          <Box mt={2} mb={3}>
            <input
              accept=".apk,.aab"
              id="app-upload"
              type="file"
              name="file"
              onChange={handleUploadFormChange}
              style={{ display: "none" }}
              required
            />
            <label htmlFor="app-upload">
              <Button
                variant="outlined"
                component="span"
                fullWidth
                startIcon={<CloudUploadIcon />}
              >
                {uploadFormData.file
                  ? uploadFormData.file.name
                  : "Choose APK File"}
              </Button>
            </label>
          </Box>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            size="large"
            disabled={uploadLoading}
            sx={{ mt: 2 }}
          >
            {uploadLoading ? <CircularProgress size={24} /> : "Upload App"}
          </Button>
        </Box>
      </DialogContent>
      <Backdrop
        open={uploadLoading}
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  );
};

export default UploadApp;
